import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noWhiteSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const isWhitespace = typeof control.value === 'string' && control.value.trim().length === 0;
        return isWhitespace ? { whitespace: true } : null;
    };
}
